// Organization type options
// These are suggested organization types that users can select from or they can type their own custom type

export const ORGANIZATION_TYPES = [
  // Academic Institutions
  'University',
  'College',
  'Community College',
  'Technical Institute',
  'Vocational School',
  'Graduate School',
  'Business School',
  'Medical School',
  'Law School',
  
  // Research Institutions
  'Research Institute',
  'Research Center',
  'Research Laboratory',
  'National Laboratory',
  'Independent Research Organization',
  'Think Tank',
  
  // Healthcare
  'Hospital',
  'Medical Center',
  'Clinic',
  'Healthcare Organization',
  'Public Health Organization',
  
  // Government & Public
  'Government Agency',
  'Federal Agency',
  'State Agency',
  'Local Government',
  'Public Institution',
  'Regulatory Agency',
  
  // Non-Profit
  'Non-Profit Organization',
  'Foundation',
  'Charity',
  'NGO',
  'Advocacy Organization',
  'Professional Association',
  'Scientific Society',
  
  // Private Sector
  'Company',
  'Corporation',
  'Startup',
  'Biotechnology Company',
  'Pharmaceutical Company',
  'Technology Company',
  'Consulting Firm',
  'Contract Research Organization',
  
  // Consortiums & Networks
  'Consortium',
  'Research Network',
  'Collaboration Network',
  'Industry Alliance',
  
  // Other
  'Other'
];

export default ORGANIZATION_TYPES;
